import React from 'react';
import { ScrollView } from 'react-native';
import { View } from 'react-native-web';
import {
  Android,
  credit_card_82938,
  credit_card_str,
  creditCardCodeNumber1,
  current_account_str,
  e_wallet,
  money_amount_28235,
  num_1234_567_89,
} from '../../../../../utils/DictionaryManagementUtils';
import { img_bank_account, img_credit_card, img_e_wallet } from '../../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import TransferAmountComponent from '../../../AuxiliaryComponent/AmountSim/TransferAmountComponent';
import ArrowInsideSmallSquareBtn from '../../../AuxiliaryComponent/ButtonComponent/ArrowInsideSmallSquareBtn';

//= ========================================================================

const SelectTransferAccountFP = ({
  globJSON,
  simPlatform,
  withArrow, isBlueBorder, withThreeCard, isAccountBalanceService, isPayBillService,
  accountInfo, slideshowRefs,
}) => {
  const getTopTitlePerService = isAccountBalanceService ? accountInfo.account_balance : accountInfo.select_paying_account;
  const myStyles = {
    viewAll: {
      width: 240,
      height: simPlatform === Android ? 221 + 48 - 12 : 221,
      marginLeft: 0,
      flexDirection: 'column',
    },
    arrowStyle: {
      paddingVertical: 20,
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      headlineText={isPayBillService ? accountInfo.title : getTopTitlePerService}
      floatingChildren={withArrow && (
        <View style={myStyles.arrowStyle}>
          <ArrowInsideSmallSquareBtn
            globJSON={globJSON}
            isPrimaryCtaColorBackground
          />
        </View>
      )}
    >
      <ScrollView
        style={myStyles.viewAll}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        <TransferAmountComponent
          globJSON={globJSON}
          simPlatform={simPlatform}
          source={img_bank_account}
          txt0={current_account_str}
          txt1={credit_card_82938}
          txt2={money_amount_28235}
          isBlueBorder={isBlueBorder}
        />
        <TransferAmountComponent
          globJSON={globJSON}
          simPlatform={simPlatform}
          source={img_e_wallet}
          txt0={e_wallet}
          txt1={num_1234_567_89}
          txt2={money_amount_28235}
        />

        {withThreeCard
                && (
                <TransferAmountComponent
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  source={img_credit_card}
                  txt0={credit_card_str}
                  txt1={creditCardCodeNumber1}
                />
                )}
      </ScrollView>
    </FullPageSimulator>
  );
};

export default SelectTransferAccountFP;
